<template>
<div id='infopoint-table'>
   <TableActionHeader 
        ref="actionHeader"
        @filterChange="onFilterChange" 
        :selectOptions="statusOptions" 
        :selected="statusFilter"
        @filterSelect="onFilterSelect"
        :selectOptions2="groupsList" 
        :selected2="groupFilter"
        @filterSelect2="onGroupSelect"
        @newItem="onNewItem"
        :newButton="$UIPrivilegeC('devices/infopoints')">
    </TableActionHeader> 

    <b-table
        ref="table"
        responsive="sm" 
        striped 
        hover 
        selectable sticky-header="calc(100vh - 350px)" 
        select-mode="single" 
        @row-selected="onRowSelected" 
        :items="filteredInfopointList" 
        :fields="fields" 
        :small="true"
        :no-provider-paging="true" 
        :no-provider-filtering="true" 
        :per-page="perPage" 
        :current-page="currentPage"
        :filter="filter"
        :filter-function="filterFunction"
        @filtered="onFiltered"
        :busy="loading">
        <template v-slot:cell(status)="data">
            <b-icon v-if="data.value=='ONLINE'" icon="check-square-fill" scale='2' variant="success" :title="$t('infopoints.states.ONLINE')"></b-icon>
            <b-icon v-if="data.value=='OFFLINE-1'" icon="exclamation-square-fill" scale='2' variant="warning" :title="$t('infopoints.states.OFFLINE-1')"></b-icon>
            <b-icon v-if="data.value=='OFFLINE-2'" icon="dash-square-fill" scale='2' variant="danger" :title="$t('infopoints.states.OFFLINE-2')"></b-icon>
            <b-icon v-if="data.value=='UNKNOWN'" icon="question-square-fill" scale='2' variant="secondary" :title="$t('infopoints.states.UNKNOWN')"></b-icon>

            <b-icon v-if="data.value=='IN_REPAIR'" icon="tools" scale='1.5' variant="dark" :title="$t('infopoints.modes.IN_REPAIR')"></b-icon>
            <b-icon v-if="data.value=='IN_STORAGE'" icon="inboxes" scale='1.5' variant="dark" :title="$t('infopoints.modes.IN_STORAGE')"></b-icon>
            <b-icon v-if="data.value=='NOT_WORKING'" icon="x-circle" scale='2' variant="dark" :title="$t('infopoints.modes.NOT_WORKING')"></b-icon>
            <b-icon v-if="data.value=='NOT_TRACKED'" icon="eye-slash" scale='2' variant="dark" :title="$t('infopoints.modes.NOT_TRACKED')"></b-icon> 
        </template>
        <template v-slot:cell(groups)="data">
            <div v-for="group in data.item.device?.groups" :key="group.id"> 
                <t-badge :background="getGroupColor(group.id)">{{ group.name }}</t-badge>
            </div>
        </template>
        <template v-slot:cell(views)="data">
            <!--<span v-for="view in data.item.timetableviews" :key="view" style="display: block;">{{ view }}</span> -->
            <!--div v-for="view in data.item.timetableviews" :key="view"> 
                <router-link v-b-tooltip.left :title='timetableViewTooltip(view)' :to="{ path: '/content/timetables', query: { id: view  }}">{{ view }} </router-link>
            </div-->
            <div v-if="data.item.content && data.item.content[0]">
                <div>
                    <b-icon icon="eye-fill" /><router-link v-b-tooltip.left :title='timetableViewTooltip(data.item.content[0].timetableView)' :to="{ path: '/content/timetables', query: { id: data.item.content[0].timetableView  }}">{{ data.item.content[0].timetableView }} </router-link>       
                </div>
                <div><b-icon icon="columns" />{{ data.item.content[0].layoutname }}</div>
                <div v-if='timetableViewStops[data.item.content[0].timetableView]'>
                    <div v-for="stop in timetableViewStops[data.item.content[0].timetableView]" :key="stop" class='stop'><b-icon icon="geo-alt-fill" variant='danger' />{{ stop }}</div>
                    
                </div>
            </div>
        </template>
        <template #table-busy>
            <Loading />
        </template>
        <template #empty>
            <span>{{ $t('select_and_tables.empty_filtered') }}</span>
        </template>
        <template #empty-filtered>
            <span>{{ $t('select_and_tables.empty_filtered') }}</span>
        </template>
    </b-table>

    <TablePagination 
        :total-rows="totalRows" 
        :per-page="perPage" 
        @pageChange="onPageChange">
    </TablePagination>

    </div>
</template>

<script>

import infopoint from '@/store/displays/infopoint'
import timetableview from '@/store/content/timetableview';
import deviceGroup from '@/store/displays/deviceGroup'

export default {
   /* props: ['filter', 'statusFilter', 'item'], */
   props: ['item'], 
   data: function() {
        return {
            perPage: 15,
            currentPage: 1,
            filteredRows: 1,
            filteredInfopoints: [],
            filter: "",
            statusFilter: "ALL",
            statusOptions: [
                /*{ id: 'ALL', label: this.$t('infopoints.states.ALL'), icon: 'list' }, */
                { id: 'ALL', label: this.$t("filter.no"), icon: 'filter', caption: this.$t("infopoints.status") },
                { id: 'ONLINE', label: this.$t('infopoints.states.ONLINE'), icon: 'check-square-fill', variant: 'success' },
                { id: 'OFFLINE-1', label: this.$t('infopoints.states.OFFLINE-1'), icon: 'exclamation-square-fill', variant: 'warning' },
                { id: 'OFFLINE-2', label: this.$t('infopoints.states.OFFLINE-2'), icon: 'dash-square-fill', variant: 'danger' },
                { id: 'UNKNOWN', label:  this.$t('infopoints.states.UNKNOWN'), icon: 'question-square-fill', variant: 'secondary' },
                { id: 'IN_REPAIR', label: this.$t('infopoints.modes.IN_REPAIR'), icon: 'tools' },
                { id: 'IN_STORAGE', label: this.$t('infopoints.modes.IN_STORAGE'), icon: 'inboxes' },
                { id: 'NOT_WORKING', label: this.$t('infopoints.modes.NOT_WORKING'), icon: 'x-circle' },
                { id: 'NOT_TRACKED', label: this.$t('infopoints.modes.NOT_TRACKED'), icon: 'eye-slash' }
            ],
            groupFilter: "ALL"
        }
    },
    watch: {
        statusFilter(){
            this.currentPage = 1;
        },
        item(){
            if(!this.item)
                this.$refs.table.clearSelected();
        }
    },
    computed: {
        infopointList() {
            return this.$store.getters['infopoint/infopointList'];
        },
        filteredInfopointList() {
            let infopoints = this.infopointList;

            if (this.statusFilter !== 'ALL') {
                infopoints = infopoints.filter(infopoint => this.statusFilter === this.getInfopointState(infopoint));
            }

            if (this.groupFilter !== 'ALL') {
                infopoints = infopoints.filter(infopoint => infopoint.device?.groups?.some(group => String(group.id) === this.groupFilter));
            }

            return infopoints;
        },
        groupsList() {
            const groups = new Map();

            this.$store.state.infopoint.infopointList.forEach(infopoint => {
                infopoint.device?.groups?.forEach(group => {
                    if (group?.id && !groups.has(group.id)) {
                        let background = this.getGroupColor(group.id);
                        groups.set(group.id, { id: String(group.id), label: group.name, background: background, class: "infopoint-group-option" });
                    }
                });
            });

            return [
                { id: 'ALL', label: this.$t("filter.no"), icon: 'filter', caption: this.$t("infopoints.group") },
                ...groups.values()
            ];
        },
        groupsMap(){
            let groups = new Map();
            this.$store.state.deviceGroup.deviceGroupList.forEach(group => {
                groups.set(group.id, group);
            });

            return groups
        },
        loading() {
            return this.$store.state.infopoint.infopointList.length === 0;
        },
        fields() {
            return [
                { key: "status", 
                    label: this.$t('infopoints.status'),
                    tdClass: 'statusCellClass',
                    formatter: 'getState',
                    sortable: true 
                },
                { key: "uniqueId", label: this.$t('infopoints.id'), sortable: true, tdClass: 'id' },
                { key: "name", label: this.$t('infopoints.name'), sortable: true, tdClass: 'name' },
                { key: "groups", label: this.$t('infopoints.group'), sortable: true, tdClass: 'group'},
                { key: "views", label: this.$t('infopoints.views'), sortable: true, tdClass: 'content' },
               /* { key: "content[0].layoutname", label: this.$t('infopoints.layout'), sortable: true },      */ 
            ];
        },
        totalRows() {
            if (!this.filter) {
                return this.filteredInfopointList.length;
            }
            return this.filteredRows;
        },
        timetableViews() {
            return this.$store.state.infopoint.timetableViews;
        },
        screenshots() {
            return this.$store.state.infopoint.screenshots;
        },
        timetableViewStops() {
            return this.$store.state.timetableview.stops;
        },
    },
    beforeCreate: function() {
        if (!this.$store.state.infopoint) {
            this.$store.registerModule("infopoint", infopoint);
        }
        if (!this.$store.state.timetableview) {
            this.$store.registerModule("timetableview", timetableview);
        }        
        if (!this.$store.state.deviceGroup) {
            this.$store.registerModule('deviceGroup', deviceGroup)
        }
        this.$store.dispatch("timetableview/list");
        this.$store.dispatch("infopoint/getInfopointList");
        this.$store.dispatch('deviceGroup/getDeviceGroupList')
        this.$store.dispatch('timetableview/stops');
    },
    created(){
        var status = this.$route.query.status;
        if(status) this.statusFilter = status.toUpperCase();
    },
    mounted() {
        if(this.$route.query.id) {
            this.setFilterValue(this.$route.query.id);
            this.$nextTick(() => {
                this.handleFilterFromLayout(this.$route.query.id);
            });
        }
    },
    methods: {
        setFilterValue(newVal) {
          this.$refs.actionHeader.setFilterValue(newVal);
          this.filter = newVal;
        },
        filterFunction(item, filter) {
            let searchWords = filter.toLowerCase().split(' ');
            let searchText = item.uniqueId + " " + item.name;

            if(item.content && item.content.length > 0){
                searchText += " " + item.content[0].timetableView + " " + item.content[0].layoutname;

                let stops = this.getTimetableViewStops(item.content[0].timetableView);
                for(let stop of stops)
                     searchText += " " + stop;
            }
          
            searchText = searchText.toLowerCase();

            return searchWords.every(word => searchText.includes(word));
        },
        toLowerCase(input) {
            return String(input || '').toLowerCase();
        },
        onNewItem() {
            this.$emit('newItem');
        },
        onFilterChange(filter) {
            this.filter = filter;
        },
        onFilterSelect(id){
            this.statusFilter = id;
        },
        onGroupSelect(id){
            this.groupFilter = id;
        },
        onSelectInfopoint(item) {
            this.$store.commit('infopoint/changeSelectedInfopoint', item);
            this.$emit('selectItem', item);
        },
        handleFilterFromLayout(uniqueId) {
            const filteredItems = this.filteredInfopointList.filter(item => 
                this.filterFunction(item, uniqueId)
            );
            if (filteredItems.length > 0) {
                this.$refs.table.selectRow(0);
                this.onSelectInfopoint(filteredItems[0]);
            }
        },
        onPageChange(page) {
            this.currentPage = page;
        
            /*
            var idList = [];
            var items = !this.filter ? this.infopointList : this.filteredInfopoints;
            var start = page * this.perPage - this.perPage;
            var end = Math.min(page * this.perPage, items.length);
            for (var i = start; i < end; i++) {
                //console.log(items[i].uniqueId);
                // Tarkistettava ensin josko näkymät löytyvät jo muistista.
                if (!this.timetableViews[items[i].id]) {
                    idList.push(items[i].id);
                }
            }
            if (idList.length > 0) {
                //console.log('getTimetableViews');
                this.$store.dispatch('infopoint/getTimetableViews', idList);
            }
            */
        },
        onFiltered(filteredItems) {
            this.filteredRows = filteredItems.length
            this.currentPage = 1

            /*
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.filteredRows = filteredItems.length;
            this.currentPage = 1;

            var idList = [];
            this.filteredInfopoints = filteredItems;
            var j = 0;
            for (const i in filteredItems) {
                //console.log(filteredItems[i].uniqueId);
                // Tarkistettava ensin josko näkymät löytyvät jo muistista.
                if (!this.timetableViews[filteredItems[i].id]) {
                    idList.push(filteredItems[i].id);
                }
                j++;
                if (j >= this.perPage)
                    break;
            }
            if (idList.length > 0) {
                //console.log('getTimetableViews');
                this.$store.dispatch('infopoint/getTimetableViews', idList);
            }
            */
        },
        updateScreenshot(identifier) {
            this.$store.dispatch('infopoint/getScreenshot', identifier);
        },
        onRowSelected(items){
            if(items[0]) {
                this.onSelectInfopoint(items[0]);
            }
        },
        statusCellClass(value, key, item){
            var cellClass = "status " + this.getState(value, key, item);
            return cellClass;
        },
        getState(value, key, item){
           return this.getInfopointState(item);
        },
        getInfopointState(item){
            var state = item.device ? item.device.mode : null;
            if(!state || state == 'IN_OPERATION'){
                if(item.status.infopointStatusId == '0'){ 
                    state = "UNKNOWN"
                } else {
                     if(item.status.timeStamp){
                        var now = new Date();
                        var sd = Date.parse(item.status.timeStamp);
                      
                        //var limit = 1000*60*10; //  10 min
                        //state = (now - sd < limit) ? "ONLINE" : "OFFLINE";

                        var diff = now - sd;
                        var limit1 = 1000*60*60;     //  1 h
                        var limit2 = limit1*12 ;     //  12 h
                        
                        if(diff < limit1) state = "ONLINE";
                        if(diff > limit1) state = "OFFLINE-1";
                        if(diff > limit2) state = "OFFLINE-2";

                       //console.log(item.uniqueId + ": "+ diff + " " + limit1 + " "+limit2);
                     
                    }
                    else {
                        state = "OFFLINE";
                    }
                }
            }
         
            return state;
        },
        timetableViewTooltip(timetable) {
            const TimetableViewName = this.$store.getters['timetableview/getTimeTableViewByID'](timetable);
            if (TimetableViewName && TimetableViewName.name) {
                return TimetableViewName.name;
            } else {
                return '';
            }
        },
        getGroupColor(id){
            let group = this.groupsMap.get(id);
            let color = group ? group.color : ""
            return color;
        },
        getTimetableViewStops(view){
            let viewStops = this.$store.state.timetableview.stops[view];
            return viewStops ? viewStops.slice() : [];
        }
    }
}
</script>



